import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  ClockIcon,
  CalendarIcon,
  CurrencyDollarIcon,
  CogIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
  BanknotesIcon,
} from '@heroicons/react/24/outline';

const navigation = [
  { name: 'Dashboard', to: '/', icon: HomeIcon },
  { name: 'Employees', to: '/employees', icon: UsersIcon },
  { name: 'Attendance', to: '/attendance', icon: ClockIcon },
  { name: 'Leave Requests', to: '/leaves', icon: CalendarIcon },
  { name: 'Payroll', to: '/payroll', icon: CurrencyDollarIcon },
  { name: 'Loans & Advances', to: '/loans', icon: BanknotesIcon },
  { name: 'Departments', to: '/departments', icon: BuildingOfficeIcon },
  { name: 'Positions', to: '/positions', icon: BriefcaseIcon },
  { name: 'Settings', to: '/settings', icon: CogIcon },
];

const Sidebar = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-75 z-20 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`
          fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
          lg:translate-x-0 lg:static lg:inset-0
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <div className="flex flex-col h-full">
          <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav className="mt-5 flex-1 px-2 space-y-1">
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.to}
                  onClick={() => onClose()}
                  className={({ isActive }) =>
                    `group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
                      isActive
                        ? 'bg-primary-100 text-primary-600'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                >
                  <item.icon className="mr-3 flex-shrink-0 h-6 w-6" />
                  {item.name}
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
            <div className="text-xs text-gray-500">
              <p>FiberFlow HR v1.0</p>
              <p>© 2026 FiberFlow</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
